import React from "react";
import PropTypes from "prop-types";

import IncentivePreferences from "./../../client_customizations/components/IncentivePreferences/IncentivePreferences";
import EVFilterControls from "../../client_customizations/components/EVFilterControls/EVFilterControls";

import SlideRange from "../InputComponents/SlideRange/SlideRange";
import SlideMilesDrivenDaily from "../InputComponents/SlideMilesDrivenDaily/SlideMilesDrivenDaily";
import SlideMaxBudget from "../InputComponents/SlideMaxBudget/SlideMaxBudget";
import SlideMinSeats from "../InputComponents/SlideMinSeats/SlideMinSeats";
import SelectChargerLevel from "../InputComponents/SelectChargerLevel/SelectChargerLevel";

import {FormattedMessage, useIntl} from 'react-intl';

const MatchScoreOptions = ({ electricVehicles, incentives, location, vehicles }) => {
  const intl = useIntl()
  return (
    <div className="input-well MatchScoreOptions">
      <p className="h2">
        <FormattedMessage 
          id="evs.matchScoreOptions"
          defaultMessage="Filter"
          description="Filter"
        />
      </p>
      <SlideMaxBudget />

      <IncentivePreferences
        electricVehicles={electricVehicles}
        incentives={incentives}
        location={location}
        titleText={intl.formatMessage ? intl.formatMessage({ id: "personalizeIncentives", defaultMessage: "Personalize Incentives"}) : "Personalize Incentives"}
        btnText={intl.formatMessage ? intl.formatMessage({ id: "personalizeIncentives", defaultMessage: "Personalize Incentives"}) : "Personalize Incentives"}
        btnSubtle
      />

      <SlideRange />

      <EVFilterControls vehicles={vehicles} />

      <div style={{ height: "1rem" }} />

      <SlideMilesDrivenDaily ariaControls="electric-vehicles-catalog" />

      <SlideMinSeats />
      <SelectChargerLevel />

      <div className="top-margin" style={{marginTop:20, color: "#191919"}}>
        <FormattedMessage
          id="evs.disclaimer"
          defaultMessage="Vehicles displayed may not reflect actual availability. We do not endorse or recommend any specific vehicle or car manufacturer."
          description="EVs Disclaimer"
        />
      </div>
    </div>
  );
};

export default MatchScoreOptions;

MatchScoreOptions.propTypes = {
  electricVehicles: PropTypes.array,
  incentives: PropTypes.array,
  location: PropTypes.object
};
